import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { FadeUp } from "./Reveal";
import { FAQS } from "@/data";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="py-24 lg:py-40 bg-[#0A0A0A] border-t border-[#333]" data-testid="faq">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <FadeUp className="lg:col-span-4">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-[#FF4D00]" aria-hidden="true" />
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#FF4D00]">FAQ</span>
          </div>
          <h2 className="font-display font-bold uppercase tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.9]">
            Common<br />Questions
          </h2>
        </FadeUp>

        <div className="lg:col-span-8 border-t border-[#333]">
          {FAQS.map((f, i) => {
            const active = open === i;
            return (
              <div key={i} className="border-b border-[#333]" data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(active ? -1 : i)}
                  className="w-full flex items-start justify-between gap-6 py-7 text-left group"
                  data-testid={`faq-toggle-${i}`}
                  aria-expanded={active}
                >
                  <span className="font-display font-bold uppercase tracking-tight text-white text-xl lg:text-2xl group-hover:text-[#FF4D00] transition-colors">
                    {f.q}
                  </span>
                  <Plus
                    size={24}
                    className={`shrink-0 mt-1 text-[#FF4D00] transition-transform duration-300 ${active ? "rotate-45" : ""}`}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {active && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="font-mono font-light text-[#A3A3A3] text-base leading-relaxed pb-8 max-w-2xl">
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
